import React from 'react';
import { Input } from 'reactstrap';

const CheckBox = ({checkboxList, onChange, onchangeTextbox, textboxValue}) => {

  return (
    <>
      {
        checkboxList.map(option => (
          <div key={option.value} className='mb-4'>
            <label className={`assessment-checkbox ${option.isChecked && 'assessment-checkbox-border'}`} htmlFor={option.value}>
              <span>{option.label}</span>
              <Input 
                type='checkbox' 
                className='float-end mt-0'
                id={option.value}
                value={option.value}
                checked={option.isChecked}
                onChange={(e) => onChange(e,option)}
              />
            </label>
            {option.label === 'Other' && option.isChecked && <Input type='text' value={textboxValue} className='other-textbox mt-3' placeholder='Please specify your condition' onChange={onchangeTextbox} />}
          </div>
        ))
      }
    </>
  );
}

export default CheckBox;